import { IconWorkInProgress } from '@bynder/icons';
import { Box, EmptyState } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';

export const ComingSoonWidget = () => {
  const { translate } = useTranslate();

  return (
    <Box marginTop="6">
      <EmptyState
        icon={<IconWorkInProgress />}
        title=""
        text={translate('WIDGETS_INSPECTOR.NO_STYLING_WIDGET_TEXT')}
      />
    </Box>
  );
};
